import { render, staticRenderFns } from "./GameChat.vue?vue&type=template&id=55813edf&scoped=true"
import script from "./GameChat.vue?vue&type=script&lang=js"
export * from "./GameChat.vue?vue&type=script&lang=js"
import style0 from "./GameChat.vue?vue&type=style&index=0&id=55813edf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55813edf",
  null
  
)

export default component.exports